import { useState } from "react";
import { DateRangePicker, SelectPicker } from "rsuite";
import { formatDateRange } from "../../utils/utils";
import searchIcon from "../../assets/icons/search-icon.svg";
import filterIcon from "../../assets/icons/filter-icon.svg";
import downloadIcon from "../../assets/icons/download-icon.svg";
import { DISPUTE_STATUS_FILTER_OPTIONS } from "../../constants/disputes";
import "./BookingsTableFilters.css";

// Filter bar for the disputes view. Mirrors BookingsTableFilters (and reuses
// its stylesheet) so both tables read consistently. Download is added
// alongside search + status + date filters as that feature lands.
const DisputesTableFilters = ({
  onSearch,
  searchValue,
  onViewToggle,
  statusValue,
  onStatusChange,
  onDateRangeApply,
  onDownload,
}) => {
  const [showFilters, setShowFilters] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });

  const formatDateToString = (dateObj) => {
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleDateRangeChange = (value) => {
    // Cleared, or an incomplete range → reset the filter.
    if (!value || !Array.isArray(value) || value.length !== 2) {
      setDateRange({ start: null, end: null });
      if (onDateRangeApply) onDateRangeApply(null, null);
      return;
    }

    const [startDateObj, endDateObj] = value;
    if (
      !(startDateObj instanceof Date) ||
      !(endDateObj instanceof Date) ||
      isNaN(startDateObj.getTime()) ||
      isNaN(endDateObj.getTime())
    ) {
      return;
    }

    const start = formatDateToString(startDateObj);
    const end = formatDateToString(endDateObj);
    setDateRange({ start, end });
    if (onDateRangeApply) onDateRangeApply(start, end);
  };

  const getDateRangeValue = () => {
    if (dateRange.start && dateRange.end) {
      const start = new Date(dateRange.start + "T00:00:00");
      const end = new Date(dateRange.end + "T00:00:00");
      if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
        return [start, end];
      }
    }
    return null;
  };

  return (
    <div className="bookings-filters">
      <div className="bookings-filters__search">
        <img src={searchIcon} alt="Search" className="search-icon" />
        <input
          type="text"
          placeholder="Search"
          className="search-input"
          value={searchValue || ""}
          onChange={(e) => onSearch && onSearch(e.target.value)}
        />
      </div>

      <div className="bookings-filters__actions">
        <button
          className={`filter-button ${showFilters ? "filter-button--active" : ""}`}
          onClick={() => setShowFilters((v) => !v)}
        >
          <img src={filterIcon} alt="Filter" />
          Filters
        </button>

        {onViewToggle && (
          <button className="view-disputes-button" onClick={onViewToggle}>
            View Transactions
          </button>
        )}

        <button className="download-button" onClick={onDownload}>
          <img src={downloadIcon} alt="Download" />
          Download
        </button>
      </div>

      {showFilters && (
        <div className="bookings-filters__row">
          <div className="bookings-filters__dropdowns">
            <div className="filter-dropdown">
              <SelectPicker
                data={DISPUTE_STATUS_FILTER_OPTIONS}
                value={statusValue || ""}
                onChange={(value) => onStatusChange && onStatusChange(value || "")}
                placeholder="Dispute Status"
                searchable={false}
                cleanable={true}
                block
                className="filter-select-picker"
              />
            </div>
          </div>
          <div className="bookings-filters__date-ranges">
            <div className="date-range-wrapper">
              <div className="date-range-wrapper__label"></div>
              <DateRangePicker
                block
                value={getDateRangeValue()}
                placeholder="Disputed Date Range"
                onChange={handleDateRangeChange}
                format="dd-MM-yyyy"
                renderValue={formatDateRange}
                className="date-range-picker"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DisputesTableFilters;
